<template>
    <ds-dropdown
        icons
        position="bottom-end"
        class="broadcast-options"
    >
        <ds-icon-button name="more-vertical" data-qa="email-broadcast-options-vertical-menu" />

        <ul slot="menu" class="dropdown-menu-list">
            <li
                v-if="showEdit"
                class="option dropdown-menu-item"
                data-qa="email-broadcast-edit"
                @click.prevent="$emit('edit')"
            >
                <ds-icon class="option-icon" name="edit" />

                <span>{{ $options.TEMPLATE_CONSTANTS.EDIT }}</span>
            </li>

            <li
                v-if="showCopy"
                class="option dropdown-menu-item"
                data-qa="email-broadcast-copy"
                @click.prevent="$emit('copy')"
            >
                <ds-icon class="option-icon" name="copy" />

                <span>{{ $options.TEMPLATE_CONSTANTS.COPY }}</span>
            </li>

            <li
                v-if="showReport"
                class="option dropdown-menu-item"
                @click.prevent="$emit('report')"
            >
                <ds-icon class="option-icon" name="chart" />

                <span>{{ $options.TEMPLATE_CONSTANTS.VIEW }}</span>
            </li>

            <li
                v-if="showCancel"
                class="option dropdown-menu-item"
                data-qa="email-broadcast-stop"
                @click.prevent="$emit('cancel')"
            >
                <ds-icon class="option-icon" name="x" />

                <span>{{ $options.TEMPLATE_CONSTANTS.STOP }}</span>
            </li>

            <li
                v-if="showReschedule"
                class="option dropdown-menu-item"
                data-qa="email-broadcast-reschedule"
                @click.prevent="$emit('reschedule')"
            >
                <ds-icon class="option-icon" name="clock" />

                <span>{{ $options.TEMPLATE_CONSTANTS.RESCHEDULE }}</span>
            </li>

            <li
                v-if="showResume"
                class="option dropdown-menu-item"
                data-qa="email-broadcast-resume"
                @click.prevent="$emit('resume')"
            >
                <ds-icon class="option-icon" name="play" />

                <span>{{ $options.TEMPLATE_CONSTANTS.RESUME }}</span>
            </li>

            <li
                v-if="showDelete"
                class="option dropdown-menu-item delete"
                data-qa="email-broadcast-delete"
                @click.prevent="$emit('delete')"
            >
                <ds-icon class="option-icon" name="trash-2" />

                <span>{{ $options.TEMPLATE_CONSTANTS.DELETE }}</span>
            </li>
        </ul>
    </ds-dropdown>
</template>

<script>
import moment from 'moment-timezone';
import {
    BROADCAST_STATUS,
    SCHEDULE_DATE_FORMAT,
    FURTHEST_TIMEZONE,
} from '../constants/emailBroadcast.constants';

export const TEMPLATE_CONSTANTS = {
    EDIT: 'Edit',
    COPY: 'Make a copy',
    VIEW: 'View report',
    STOP: 'Stop sending',
    RESCHEDULE: 'Reschedule',
    RESUME: 'Resume sending',
    DELETE: 'Delete',
};

export const BARD_BUILDER = 'BardEmailBuilder';
export const BARD_CODEMIRROR_BUILDER = 'CodeMirror';

export default {
    TEMPLATE_CONSTANTS,
    BARD_BUILDER,

    props: {
        status: String,
        scheduleDateWithoutTimeZone: String,
        scheduledTimeZoneId: String,
        editor: String,
        useContactTimeZone: Boolean,
        isBardBuilderDisabled: Boolean,
    },

    computed: {
        showEdit() {
            return BROADCAST_STATUS[this.status] === BROADCAST_STATUS.DRAFT;
        },

        showReport() {
            return BROADCAST_STATUS[this.status] === BROADCAST_STATUS.DONE;
        },

        showCancel() {
            const eligibleStatuses = [
                BROADCAST_STATUS.QUEUED,
                BROADCAST_STATUS.PROCESSING,
                BROADCAST_STATUS.RESCHEDULING,
            ];

            return eligibleStatuses.includes(BROADCAST_STATUS[this.status]);
        },

        showReschedule() {
            if (BROADCAST_STATUS[this.status] !== BROADCAST_STATUS.QUEUED) {
                return false;
            }

            let scheduleDate;

            if (!this.useContactTimeZone) {
                scheduleDate = moment.tz(this.scheduleDateWithoutTimeZone, SCHEDULE_DATE_FORMAT, this.scheduledTimeZoneId);
            } else {
                scheduleDate = moment.tz(this.scheduleDateWithoutTimeZone, SCHEDULE_DATE_FORMAT, FURTHEST_TIMEZONE);
            }

            return moment().add(30, 'minutes').isBefore(scheduleDate);
        },

        showResume() {
            return BROADCAST_STATUS[this.status] === BROADCAST_STATUS.CANCELLED;
        },

        showDelete() {
            return BROADCAST_STATUS[this.status] === BROADCAST_STATUS.DRAFT;
        },

        showCopy() {
            return !(this.isBardBuilderDisabled && (this.editor?.startsWith(BARD_BUILDER) || this.editor?.startsWith(BARD_CODEMIRROR_BUILDER)));
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    $options-min-width: px-to-rem(200px);

    .broadcast-options {
        --dropdown-minwidth: #{$options-min-width};
    }

    .option {
        --icon-color: #{$color-gray-700};

        &.delete {
            --icon-color: #{$color-red};
        }
    }
</style>
